export default `
  subscription OnUpdateCardType($workflowId: String) {
    onUpdateCardType(workflowId: $workflowId) {
      workflowId
      cardTypes {
        id
        title
        description
        color {
          red
          green
          blue
          rgb
        }
        showInBacklog
        generateWithAI
        domainModelRole
        defaultType
        order
        workflowId
        createdAt
      }
    }
  }
`
